import { get, post } from '@/api/request.js'
import { requestData } from '@/common/js/commont.js'

// 获取触发器列表
export const getTriggerList = data => post('/api/warn/getTriggerList', requestData(data))

// 添加触发器
export const addTrigger = data => post('/api/warn/addTrigger', requestData(data))

// 编辑触发器
export const editTrigger = data => post('/api/warn/editTrigger', requestData(data))

// 删除触发器
export const delTrigger = data => post('/api/warn/delTrigger', requestData(data))

//获取用户设备接收参数
export const getDeviceParams = data => post('/api/device/getDeviceParams', requestData(data))
